import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getMonitors,
  getMonitorInfo,
  createMonitor,
  updateMonitor,
  deleteMonitor,
} from "../api/monitors";
import type {
  CreateMonitorRequest,
  UpdateMonitorRequest,
} from "../api/monitors";

export const useMonitors = () => {
  return useQuery({
    queryKey: ["monitors"],
    queryFn: getMonitors,
  });
};

export const useMonitorInfo = (monitorId: number | null) => {
  return useQuery({
    queryKey: ["monitors", "info", monitorId],
    queryFn: () => getMonitorInfo(monitorId!),
    enabled: monitorId !== null,
  });
};

export const useCreateMonitor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateMonitorRequest) => createMonitor(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["monitors"] });
    },
  });
};

export const useUpdateMonitor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateMonitorRequest }) =>
      updateMonitor(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["monitors"] });
    },
  });
};

export const useDeleteMonitor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteMonitor(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["monitors"] });
    },
  });
};
